import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { JobsProvider } from './context/JobsContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ForEmployers from './pages/ForEmployers';
import ForJobSeekers from './pages/ForJobSeekers';
import CandidateFAQs from './pages/CandidateFAQs';
import EmployerFAQs from './pages/EmployerFAQs';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import JobApplication from './pages/JobApplication';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './styles/App.css';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navbar />}
      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/for-employers" element={<ForEmployers />} />
          <Route path="/for-job-seekers" element={<ForJobSeekers />} />
          <Route path="/candidate-faqs" element={<CandidateFAQs />} />
          <Route path="/employer-faqs" element={<EmployerFAQs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/apply/:jobId" element={<JobApplication />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <JobsProvider>
        <AppContent />
      </JobsProvider>
    </AuthProvider>
  );
}

export default App;
